import type { Variants } from 'framer-motion';

// ============================================================
// Lume institucional — motion/variants
// ============================================================
// Variantes Framer Motion compartilhadas. Todas com easing único
// (cubic-bezier 0.2, 0.8, 0.2, 1) e duração ≤ 600ms — Princípio 11
// dos princípios do programa (low-stim, sem estímulo prolongado).
//
// `useReducedMotion` (do framer-motion) reduz automaticamente.
// ============================================================

const ease: [number, number, number, number] = [0.2, 0.8, 0.2, 1];

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease },
  },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.6, ease } },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.94 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.45, ease } },
};

export const slideInLeft: Variants = {
  hidden: { opacity: 0, x: -32 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.55, ease } },
};

export const slideInRight: Variants = {
  hidden: { opacity: 0, x: 32 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.55, ease } },
};

export const stagger = (delay = 0.08): Variants => ({
  hidden: {},
  visible: {
    transition: {
      staggerChildren: delay,
      delayChildren: 0.05,
    },
  },
});

// Hero entry — orquestra mark + headline + sub + CTAs com timing apurado
export const heroParent: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.09,
      delayChildren: 0.1,
    },
  },
};

export const heroChild: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease },
  },
};

export const heroMark: Variants = {
  hidden: { opacity: 0, scale: 0.85, rotate: -8 },
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    transition: { duration: 0.7, ease },
  },
};

// Reveal padrão para uso com `whileInView`
export const revealOnView = {
  initial: 'hidden' as const,
  whileInView: 'visible' as const,
  viewport: { once: true, margin: '-10% 0px' },
};
